import React from 'react';
import ICSDPage from './ICSDPage';
import {
  downloadTemplate,
  validateCalibrationSwapFile,
  commitCalibrationSwapFile,
  downloadCalibrationReport,
} from '../../../../api/ICSD';
import toast from '../../../../actions/toast';

const ICSD = (props) => {
  const [loading, setLoading] = React.useState(false);
  const [isCommitting, setIsCommitting] = React.useState(false);
  const [validationResult, updateValidationResult] = React.useState(null);
  const [commitResult, updateCommitResult] = React.useState(null);
  function handleDownloadTemplate() {
    downloadTemplate();
  }
  function handleValidateFile(file) {
    setLoading(true);
    updateValidationResult(null);
    updateCommitResult(null);
    validateCalibrationSwapFile(file)
      .then((resp) => updateValidationResult(resp))
      .catch((err) => toast.error(err.response.data.error.message))
      .finally(() => setLoading(false));
  }
  function handleCommitFile(file) {
    setIsCommitting(true);
    commitCalibrationSwapFile(file)
      .then(async (resp) => {
        updateCommitResult(resp);
        await downloadCalibrationReport(resp.id);
      })
      .catch((err) => toast.error(err.response.data.error.message))
      .finally(() => setIsCommitting(false));
  }
  return (
    <ICSDPage
      downloadTemplate={handleDownloadTemplate}
      validateFile={handleValidateFile}
      validationResult={validationResult}
      commitFile={handleCommitFile}
      loading={loading}
      isCommitting={isCommitting}
      commitResult={commitResult}
    />
  );
};

export default ICSD;
